// extracted by mini-css-extract-plugin
module.exports = {"container":"etradeDetails_container__1lAdS","search":"etradeDetails_search__1anvA","searchUser":"etradeDetails_searchUser__2P9xh","searchBtn":"etradeDetails_searchBtn__3tVlI"};